import { Components, Inputs } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import { useTheme } from "styled-components";

import { CreatePostModalContext } from "../../..";
import { API_CALLS } from "../../../../../../../../../API/api_calls";
import { API_PATHS } from "../../../../../../../../../API/api_paths";
import {
  Divider,
  LabelContainer,
} from "../../../../../../../../../commonStyles";
import { useAppSelector } from "../../../../../../../../../redux";
import { AudioBackground } from "../../../../../../../../Common";
import { FlexRowEnd } from "../../../../../../../../Common/Styles";
import Input from "../../../../../../../../Input";
import { AudioContainer } from "./style";

const AudioMeta = () => {
  const { typography } = useTheme();
  const { post_id } = useAppSelector((state) => state.posts);
  const { audio_id, audioBackgroundImage, gradients, } = useAppSelector(
    (state) => state.postAudio
  );
  const { setIsAudioOpen, setPostContentOrder, formik } = useContext(
    CreatePostModalContext
  );
  const { values, setFieldValue, validateField, setFieldError } = formik;
  const remainingCharacters = 500 - (values.audio_description?.length ?? 0);

  return (
    <AudioContainer>
      <FlexRowEnd>
        <Components.IconButton
          disabled={false}
          iconType="X"
          kind="Secondary"
          size="Small"
          onClick={() => {
            API_CALLS.POSTAUDIO.deleteAudioFromAPost({
              post_id,
              audio_id,
            });
            setIsAudioOpen(false);
            setPostContentOrder((prev) =>
              prev.filter((item) => item !== "audio")
            );
            const audioFields = ["audio_title", "audio_description"];
            audioFields.forEach((field) => {
              setFieldValue(field, "");
              setFieldError(field, undefined);
            });
          }}
        />
      </FlexRowEnd>
      <Divider />
      <LabelContainer>
        <Components.Text
          style={{ tokenStyle: typography.Heading.XXS }}
          text="Audio Headline"
          fontWeight="font-weight-semibold"
          lineHeight="line-height-50"
        />
      </LabelContainer>
      <Input
        fieldName="audio_title"
        idPrefix="create-audio"
        isRequired
        placeholder="Add a headline to your audio clip"
        size="Medium"
      />
      <LabelContainer>
        <Components.Text
          style={{ tokenStyle: typography.Heading.XXS }}
          text="Description"
          fontWeight="font-weight-semibold"
          lineHeight="line-height-50"
        />
      </LabelContainer>
      <Inputs.Textarea
        fieldName="audio-description"
        idPrefix="create-audio"
        isRequired
        placeholder="Text"
        size="Medium"
        value={values.audio_description}
        onChangeHandler={(value) => {
          setFieldValue("audio_description", value.slice(0, 500), false).then(
            () => {
              validateField("audio_description");
            }
          );
        }}
        helpText={
          remainingCharacters === 0
            ? "Max characters reached"
            : remainingCharacters <= 50
            ? `${remainingCharacters} characters remaining`
            : undefined
        }
      />
      <AudioBackground
        audioBackgroundImage={audioBackgroundImage}
        onDelete={(e) => {
          e.stopPropagation();
          API_CALLS.POSTAUDIO.deleteAnAudioImageFromAPost({
            post_id,
            content_id: audio_id,
          });
        }}
        onGradientClick={(gradient) => {
          API_CALLS.POSTAUDIO.uploadAudioBackgroundImage({
            post_id,
            gradient,
            content_id: audio_id,
          });
        }}
        gradients={gradients}
        image={
          API_PATHS.postAudio.audioBackgroundImage +
          audioBackgroundImage.image_id
        }
        onImageUploaded={(e) => {
          const files = e.target.files;
          if (files?.length) {
            API_CALLS.POSTAUDIO.uploadAudioBackgroundImage({
              post_id,
              image: files[0],
              content_id: audio_id,
            });
          }
        }}
      />
    </AudioContainer>
  );
};

export default AudioMeta;
